<template>
  <button
    v-on:click="buttonClick"
    class="quick-view-btn">
    <img src="/ui/main/img/quick-view.svg" alt="">
  </button>
</template>

<script>
export default {
  name: 'QuickView',
  data() {
    return {
      version: '0.0.1'
    }
  },
  methods: {
    buttonClick() {
      this.$emit('btn-click')
    }
  }
}
</script>
